var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appTest_bar",attrs:{"id":"appTest_bar"}})
}
var staticRenderFns = []

export { render, staticRenderFns }